// extracted by mini-css-extract-plugin
export default {"active":"_1K_9OBy-j_lgMxY7rdkyej"};